import type { ReactNode } from 'react';
import { useIdentifyDrain } from '@/hooks/useIdentifyQueue';

export function AppShell({ children }: { children: ReactNode }) {
  useIdentifyDrain();
  return (
    <div className="min-h-dvh bg-surface-secondary text-content-primary">
      <main>{children}</main>
    </div>
  );
}
